<template>
  <div>
    <Header />
    <main style="min-height: 80vh;">
      <slot></slot>
    </main>
    <Footer v-if="['Home', 'Pricing', 'PrivacyPolicy', 'TermsConditions'].includes($route.name)" />
  </div>
</template>

<script setup>
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
import { onUnmounted, watchEffect } from 'vue'
import { useRoute } from 'vue-router';

const route = useRoute();

const updateBodyBackground = () => {
  if (route.path !== '/') {
    document.body.style.backgroundColor = '#eaeef5'
  } else {
    document.body.style.backgroundColor = '' // Reset or set homepage color
  }
}

// Run on route change
watchEffect(() => {
  updateBodyBackground()
})

// Optional cleanup when component unmounts
onUnmounted(() => {
  document.body.style.backgroundColor = ''
})
</script>
